<script setup lang="ts">
import { inject, Ref } from 'vue';
import Button from 'primevue/button';

const dialogRef = inject('dialogRef') as Ref;
const dialogContent = dialogRef.value.data.dialogContent;
const typeValue = dialogRef.value.data.dialogType;
const isConfirm = dialogRef.value.options.emits.isConfirm;
const onClose = dialogRef.value.options.emits.onClose;

const clickButton = (status: string) => {
  return isConfirm(status == 'yes');
};

const onClickClose = () => {
  onClose();
};
</script>

<template>
  <div>
    <div class="popup_modal confirm" v-if="typeValue == 'confirm'">
      <div class="confirm_dialog">
        <div class="dialog_content flex justify-content-center text-lg font-bold">{{ dialogContent }}</div>
        <div class="button_section">
          <Button @click="clickButton('yes')" class="yes_btn">{{ $t('common.yes') }}</Button>
          <Button @click="clickButton('no')" class="cancel_btn">{{ $t('common.buttons.cancel') }}</Button>
        </div>
      </div>
    </div>
    <div class="popup_modal error" v-if="typeValue == 'error'">
      <div class="error_dialog">
        <div class="dialog_content flex justify-content-center text-lg font-bold">{{ dialogContent }}</div>
        <div class="button_section">
          <Button @click="onClickClose()" class="close_btn">{{ $t('common.buttons.close') }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.confirm {
  width: 200px;
  .button_section {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    .yes_btn {
      background: #1da750;
    }
  }
}
.error {
  width: 300px;
  .error_dialog {
    .button_section {
      display: flex;
      text-align: center;
      padding-top: 20px;
      justify-content: center;
    }
  }
}
</style>
